import React from 'react';
import { ISvgProps } from '../svg.types';

export const PersonalityReportNeoromantique = (props: ISvgProps) => (
  <svg
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 138 122"
    {...props}
  >
    <defs>
      <linearGradient
        id="linear-gradient"
        x1={19}
        y1={61}
        x2={119}
        y2={61}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.26} stopColor="#ffcdba" />
        <stop offset={1} stopColor="#ff9ba1" />
      </linearGradient>
      <linearGradient
        id="linear-gradient-2"
        x1={107.47}
        y1={61.06}
        x2={97.77}
        y2={92.66}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#050504" />
        <stop offset={1} stopColor="#665e58" />
      </linearGradient>
      <linearGradient
        id="linear-gradient-3"
        x1={104.82}
        y1={53.05}
        x2={95.11}
        y2={84.64}
        xlinkHref="#linear-gradient-2"
      />
      <style>
        {`.cls-4{fill:#231b1f}.cls-5{fill:#e67d64}.cls-8{fill:#33261d}.cls-9{fill:#fff}.cls-10{fill:#ec6500}.cls-11{fill:#dbdbdb}.cls-12{fill:#a40600}.cls-13{fill:#dee9f0}.cls-14{fill:#ed6a70}.cls-15{fill:#54011f}.cls-16{fill:#ef947f}.cls-17{fill:#f8a887}.cls-18{fill:#3a242f}.cls-19{fill:#09161c}.cls-22{fill:#393e53}.cls-23{fill:#f6a18a}.cls-24{fill:#ffd400}.cls-25{fill:#e8690e}`}
      </style>
    </defs>
    <g style={{ isolation: 'isolate' }}>
      <circle
        cx={69}
        cy={61}
        r={50}
        fill="url(#linear-gradient)"
        id="Calque_14"
        data-name="Calque 14"
      />
      <g id="Calque_10" data-name="Calque 10">
        <path
          d="M54.2 75.88s-1.76-3.54-4.46-2.19c.34 1.35 2.15 3.42 4.41 2.31a.17.17 0 01.05-.12z"
          fill="#e84c05"
        />
        <path
          className="cls-4"
          d="M61 88.47l3.6-.2a.33.33 0 00.3-.33v-.29a.29.29 0 00-.29-.27l-2.76.15c-.48 0-1.54.48-1.51 1z"
        />
        <path
          className="cls-5"
          d="M57.51 63.35s-6 5.94-6.57 9 10.94 15.18 10.94 15.18l2-.11c-4-5.77-4.33-12.35-8.57-14.18 2.2-.78 4.44-3.89 5.75-5s5.48-3.86 3.43-8.48zM51.69 53.23c-.07-1-.15-2.08-.22-3.12a5.55 5.55 0 01.23-2.69c.29-.56 1.08-1.47 1.69-1 .26.2.69 1.38 1.11 1.22a29.53 29.53 0 01.38 3.05c.21 2.59.6 9.12-2.12 9.1S52 58 51.69 53.23z"
        />
        <path
          className="cls-5"
          d="M43.75 61.86s8.18-3.46 8-5.85 1.63.85 2.38 2.13C55.27 60 45 62.82 45 62.82z"
        />
        <path
          className="cls-5"
          d="M43.29 60.85a1.7 1.7 0 11.05 3.4 1.7 1.7 0 11-.05-3.4z"
        />
        <path
          d="M51.63 52.4l3.37-.12v-.4l-3.39.12c.01.13.01.26.02.4z"
          fill="#f9f9f9"
        />
        <path
          className="cls-8"
          d="M39.89 79.11a12.39 12.39 0 109.38 14.8 12.4 12.4 0 00-9.38-14.8zm-5.14 22.94A11.11 11.11 0 1148 93.63a11.11 11.11 0 01-13.25 8.42z"
        />
        <path
          className="cls-9"
          d="M39.64 80.23a11.25 11.25 0 108.52 13.43 11.25 11.25 0 00-8.52-13.43zM35 101a10.08 10.08 0 1112-7.63A10.07 10.07 0 0135 101z"
        />
        <path
          className="cls-10"
          d="M30.34 85.72a8.09 8.09 0 012.5-2.44 8.46 8.46 0 016.84-1A8 8 0 0142.76 84a9.9 9.9 0 00-3.16-1.35 9.26 9.26 0 00-6.6.93 9.83 9.83 0 00-2.66 2.14z"
        />
        <path
          className="cls-9"
          d="M39.38 91a2.15 2.15 0 10-1.83 2.42A2.14 2.14 0 0039.38 91z"
        />
        <path className="cls-11" d="M61.49 88.86h-1l-1.6 4.95h1l1.6-4.95z" />
        <rect
          className="cls-8"
          x={59.48}
          y={88.07}
          width={4.01}
          height={1.37}
          rx={0.67}
        />
        <path
          className="cls-9"
          d="M63.87 67.39l-.68 3.31-.6 2.9h2.42l1.36-6.21h-2.5z"
        />
        <path
          className="cls-12"
          d="M59.42 67.17a19.63 19.63 0 013.73.57 3.69 3.69 0 002.82.37 11.09 11.09 0 002.32-.42c.25-.11 1.65-.85.54-1.9s-3.13.39-4.63.39-2.68-.35-3.85-.21a1 1 0 00-.93 1.2z"
        />
        <path
          className="cls-13"
          d="M42.56 63.28h1.57l-.33 3-.86 7.6h-1.99l1.16-7.6.45-3z"
        />
        <path
          className="cls-14"
          d="M58 95.11c-1.28-1.65-2.61-3.26-4-4.85-.67-.79-1.36-1.58-2-2.37l-2.07-2.34-2.09-2.32c-.71-.77-1.41-1.54-2.12-2.29s-1.43-1.52-2.15-2.27l-1.1-1.11-.6-.56-.28-.27c-.05-.06-.06 0-.08-.07v-.06l2.12-2.54.22.24.18.2.26.31.51.6 1 1.19q1 1.17 2.07 2.34c.69.78 1.4 1.54 2.1 2.32l2.12 2.29 2.15 2.27c.73.75 1.44 1.5 2.18 2.24 1.46 1.49 2.94 3 4.46 4.39z"
        />
        <path
          className="cls-15"
          d="M55.13 91.62q1.44 1.72 2.82 3.49l2.9-2.65c-1.08-1-2.13-2-3.17-3.08a4.71 4.71 0 00-2.55 2.24z"
        />
        <path
          className="cls-15"
          d="M61.82 89.84a4.64 4.64 0 00-2.53-.75h-.16l-1 4.8 2.7.58z"
        />
        <circle className="cls-9" cx={59.29} cy={93.78} r={3.87} />
        <path
          className="cls-11"
          d="M60.11 93.78a.82.82 0 10-.82.82.82.82 0 00.82-.82z"
        />
        <path
          className="cls-14"
          d="M41 73.83V78a21.26 21.26 0 01-1.77 6.78c-.46 1.1-1 2.18-1.55 3.24s-1.19 2.11-1.85 3.08l.87.65a37.29 37.29 0 002.11-3.08 36.83 36.83 0 001.8-3.27A23 23 0 0043 78.15l.08-1v-.93l.06-1.83v-.58z"
        />
        <path
          className="cls-14"
          d="M42.13 73.77c3.64-.07 7.28-.07 10.91 0h9.55a9.76 9.76 0 011.54.11c1.08.17 19.48-.19 20.81-.17.77 0-1.4 2.1-2.93 2.17-1 .06-17.58.74-18.3.64a8 8 0 00-1.17-.07h-1.37l-2.72-.06-2.73-.07-2.72-.01c-3.63-.12-7.27-.25-10.9-.47z"
        />
        <path
          className="cls-15"
          d="M46 76.89l-.25-.28-.51-.6 1.88.08a8.58 8.58 0 00-3.31-.36L46 76.9zM41.06 77.9a3.61 3.61 0 011.31.29c.39.25.23 1.75.23 2a18.13 18.13 0 00.37-2c-.48-.66-1.91-.29-1.91-.29zM60.25 76.47c.26 0 2.28-.37 2.42-.42a28.46 28.46 0 01-1.34 2.63l.45-2.15z"
        />
        <path d="M59.28 97.8a4 4 0 01-4-3.43 3.89 3.89 0 01.77-2.94 3.93 3.93 0 012.64-1.54h.38c6.08-.26 35.34.6 41.35.32h.14a2.27 2.27 0 01.64 4.45h-.15c-5.88 1.37-35 2.23-40.86 3v-.15.16h-.37a5.46 5.46 0 01-.54.13zm.91-.27zm40.15-7c-6 .28-35.17-.58-41.19-.32a2 2 0 00-.36 0 3.65 3.65 0 101 7.23l.34-.07h.16c5.84-.88 34.79-1.61 40.58-3h.16a2 2 0 00-.55-3.85z" />
        <rect
          className="cls-15"
          x={62.81}
          y={69.84}
          width={3.44}
          height={0.67}
          rx={0.33}
        />
        <path className="cls-11" d="M57.16 98.5h1l1.6-4.95h-1l-1.6 4.95z" />
        <rect
          className="cls-8"
          x={55.16}
          y={97.92}
          width={4.01}
          height={1.37}
          rx={0.67}
          transform="rotate(-180 57.165 98.61)"
        />
        <path
          className="cls-12"
          d="M44.32 62.7s.45 1.62 0 1.82-4.34 1-4.74.49a2.69 2.69 0 01-.08-2.34 37.82 37.82 0 014.82.03z"
        />
        <circle className="cls-12" cx={42.12} cy={63.25} r={1.63} />
        <path className="cls-11" d="M99.82 93.9h1l1.6 4.94h-1l-1.6-4.94z" />
        <rect
          className="cls-8"
          x={100.44}
          y={97.82}
          width={4.01}
          height={1.37}
          rx={0.67}
        />
        <path
          className="cls-16"
          d="M93.65 45.38a1.72 1.72 0 01-.5-1l-3.67-5.45a40.1 40.1 0 013.74-2.7c.14.12 3.14 3.55 3.14 3.55a1.8 1.8 0 01.23 1.52c-3.8 3.82-2.4 4.22-2.94 4.08z"
        />
        <path
          className="cls-17"
          d="M103 94.34v2a.71.71 0 00.57.31.52.52 0 00.56-.3c0-.09.26-1.56.26-1.56z"
        />
        <path
          className="cls-18"
          d="M100.52 97.76l2.26.06a1.23 1.23 0 01.23-.08 3.38 3.38 0 01.47 0v.14h1c0-.36-.14-1.47-.15-1.55s-.1-.12-.13-.1a1.06 1.06 0 01-.62.32c-.28 0-.53-.36-.61-.37s-.29.14-.29.14-1.76 1.06-2 1.15-.16.2-.16.29z"
        />
        <path
          className="cls-19"
          d="M104.45 97.87a3 3 0 000-.39h-.92c-.23 0-.58.2-.78.19l-2.2-.06a.37.37 0 000 .18l2.26.06a1.23 1.23 0 01.23-.08 3.38 3.38 0 01.47 0v.14z"
        />
        <path
          d="M111.32 58.22c-7.49.61-10.6.81-10.6.81l2.07 35.74h1.69c.12-.79.46-1.71.7-2.78.92-4.09 3.11-6.78.79-15.38 3.03-4.75 6.53-7.61 5.35-18.39z"
          fill="url(#linear-gradient-2)"
        />
        <path
          className="cls-9"
          d="M104.39 67.39l-.68 3.31-.6 2.9h2.42l1.36-6.21h-2.5z"
        />
        <path
          className="cls-12"
          d="M99.94 67.17a19.82 19.82 0 013.74.57 3.66 3.66 0 002.81.37 10.9 10.9 0 002.32-.42c.25-.11 1.65-.85.55-1.9s-3.14.39-4.63.39-2.69-.35-3.85-.21a1 1 0 00-.94 1.2z"
        />
        <path
          className="cls-13"
          d="M80.39 63.65h1.57l.43 2.9 1.08 7.33h-2l-.77-7.33-.31-2.9z"
        />
        <path
          className="cls-14"
          d="M98.47 95.11c-1.28-1.65-2.61-3.26-4-4.85-.67-.79-1.36-1.58-2-2.37l-2.07-2.34-2.09-2.32c-.7-.77-1.4-1.54-2.12-2.29s-1.43-1.52-2.19-2.27l-1.1-1.11-.51-.56-.27-.27a.3.3 0 00-.09-.07s-1.25-1-1.26-1l3.33-1.61.22.24.19.2.25.31.51.6 1 1.19c.69.78 1.37 1.56 2.07 2.34s1.4 1.54 2.1 2.32l2.12 2.29 2.15 2.27c.73.75 1.44 1.5 2.18 2.24 1.46 1.49 2.94 3 4.46 4.39z"
        />
        <path
          className="cls-8"
          d="M120.68 79.11a12.39 12.39 0 109.38 14.8 12.4 12.4 0 00-9.38-14.8zm-5.14 22.94a11.11 11.11 0 1113.27-8.42 11.11 11.11 0 01-13.27 8.42z"
        />
        <path
          className="cls-9"
          d="M120.43 80.23A11.25 11.25 0 10129 93.66a11.25 11.25 0 00-8.57-13.43zM115.77 101a10.08 10.08 0 1112-7.63 10.07 10.07 0 01-12 7.63z"
        />
        <path
          className="cls-10"
          d="M111.13 85.72a8.09 8.09 0 012.5-2.44 8.46 8.46 0 016.84-1 8 8 0 013.08 1.72 9.9 9.9 0 00-3.16-1.35 9.26 9.26 0 00-6.6.93 9.83 9.83 0 00-2.66 2.14z"
        />
        <path
          className="cls-12"
          d="M103.69 70.03L98.64 93.9l2.7.58 5.3-24.45h-2.95z"
        />
        <path
          className="cls-14"
          d="M103.69 70.03L98.64 93.9l2.7.58 5.3-24.45h-2.95z"
        />
        <path
          className="cls-15"
          d="M95.65 91.62q1.44 1.72 2.82 3.49l2.9-2.65q-1.61-1.51-3.17-3.08a4.71 4.71 0 00-2.55 2.24z"
        />
        <path
          className="cls-15"
          d="M102.35 89.84a4.67 4.67 0 00-2.53-.75h-.16l-1 4.8 2.7.58z"
        />
        <circle className="cls-9" cx={99.82} cy={93.78} r={3.87} />
        <path
          className="cls-11"
          d="M100.64 93.78a.82.82 0 10-1.64 0 .82.82 0 101.64 0z"
        />
        <path
          className="cls-14"
          d="M82.65 73.77c3.64-.07 7.28-.07 10.92 0h9.54a9.76 9.76 0 011.54.11 7.94 7.94 0 013 1.16 7.84 7.84 0 011.27 1c.19.2.37.4.54.61a3.92 3.92 0 01.25.32l.22.31c1 1.5 2 3 3 4.54 1.86 2.83 3.7 5.67 5.47 8.58a.78.78 0 01-.23 1.06.8.8 0 01-1.08-.16c-2.1-2.66-4.12-5.38-6.13-8.11-1.07-1.47-2.15-2.94-3.19-4.42-.07-.11-.13-.17-.18-.24l-.17-.22a4.68 4.68 0 00-.38-.39 4.63 4.63 0 00-.86-.67 5.16 5.16 0 00-2-.76 7.9 7.9 0 00-1.17-.07h-1.37l-2.64.04-2.73-.07-2.72-.08c-3.64-.12-7.27-.25-10.91-.47z"
        />
        <path
          className="cls-15"
          d="M86.54 76.89c-.08-.09-.16-.19-.25-.28l-.51-.6 1.89.08a8.58 8.58 0 00-3.31-.36l2.16 1.17zM100.78 76.47c.26 0 2.27-.37 2.42-.42a28.46 28.46 0 01-1.34 2.63l.45-2.15z"
        />
        <circle
          className="cls-9"
          cx={118.05}
          cy={91.24}
          r={2.15}
          transform="rotate(-53 117.555 91.14)"
        />
        <path d="M99.8 97.8a4 4 0 01-4-3.43 3.93 3.93 0 01.77-2.94 4 4 0 012.65-1.54h.38c6.08-.26 12.2-.54 18.2-.82h.2a2.29 2.29 0 012.24 2 2.26 2.26 0 01-1.6 2.49h-.16c-5.88 1.36-11.84 2.76-17.71 4.15v-.15.16h-.37a5.46 5.46 0 01-.6.08zm.91-.27zm17-8.17c-6 .28-12 .56-18 .82a2 2 0 00-.36 0 3.7 3.7 0 00-2.43 1.41 3.65 3.65 0 00-.71 2.71 3.7 3.7 0 004.16 3.11l.35-.07h.15c5.78-1.37 11.64-2.75 17.43-4.09h.16a2 2 0 00-.55-3.85h-.14z" />
        <rect
          className="cls-15"
          x={103.33}
          y={69.84}
          width={3.44}
          height={0.67}
          rx={0.33}
        />
        <path
          className="cls-12"
          d="M82.07 62.7s.46 1.62 0 1.82-4.33 1-4.73.49a2.72 2.72 0 01-.09-2.34 37.81 37.81 0 014.82.03z"
        />
        <path
          d="M109.92 59.68l-2.64.2-1.14.07c-1.74.28-3.46.62-5.19.9a.62.62 0 01-.65-.26c-1.51 1.51-4.37 3.7-7 6.37a2.44 2.44 0 00-.69 2.37c1.61 6 4.43 13 5.23 16.25h1.85c.14-3.25.22-9.39-.13-10.77s0-3.6-1.72-5c12.91-3.55 12.16-9.53 12.08-10.13z"
          fill="url(#linear-gradient-3)"
        />
        <path className="cls-11" d="M98.03 89.18h1l1.6 4.95h-.99l-1.61-4.95z" />
        <path className="cls-10" d="M97.67 87.35v.12s.41 0 1-.12z" />
        <path className="cls-11" d="M100.46 93.68h-1l-1.6-4.95h1l1.6 4.95z" />
        <path
          className="cls-17"
          d="M111.36 58.28c-1.24.81-6.78 3.26-9 3.5s-2.2-.63-2.2-.63l2.37-2.09 3.77-1 2-.26z"
        />
        <path
          className="cls-10"
          d="M111.36 58.28c-1.38.72-8 2.89-11.17 2.87-.43-1.39-2.17-6.76-4-9.7s-3.51-4.4-3.76-6.52 3.4-5.64 4-5.88 5.61 3.44 9.49 9.57a85.33 85.33 0 015.44 9.66z"
        />
        <path
          className="cls-17"
          d="M93.26 45c-.49 0-1-.1-1.48-.17-6 10.54-12.67 14.92-13.12 15.61s.49 1.13 2.3 3c6.2-2.33 13.09-12.78 16.18-17.92-1.29-.2-2.58-.38-3.88-.52z"
        />
        <circle
          className="cls-17"
          cx={78.53}
          cy={63.14}
          r={2.62}
          transform="rotate(-13.28 78.537 63.167)"
        />
        <path
          className="cls-12"
          d="M79.68 63.78a1.64 1.64 0 10-1.63 1.63 1.63 1.63 0 001.63-1.63z"
        />
        <path
          className="cls-10"
          d="M88.28 49.17L93 53.3s4.33-7.77 4.5-8.24-4.23-2.78-4.5-2.55-4.72 6.66-4.72 6.66z"
        />
        <path
          className="cls-10"
          d="M96.45 39.14c-.21-.12-.45-.51-.61-.55s-4 4-4.07 4.66a1.77 1.77 0 00.23 1.07l1.14-.12 2.25-1.75z"
        />
        <path
          className="cls-17"
          d="M98.11 85v1.89a.66.66 0 00.56.28.57.57 0 00.57-.3c.05-.09.28-1.51.28-1.51z"
        />
        <path
          className="cls-18"
          d="M95.62 88.38h2.26l.23-.09a3.89 3.89 0 01.48-.05v.14h1c0-.34-.13-1.4-.13-1.48a.1.1 0 00-.13-.09 1.16 1.16 0 01-.62.32c-.29 0-.53-.33-.61-.34s-.29.14-.29.14S96 88 95.77 88.09s-.15.2-.15.29z"
        />
        <path
          className="cls-19"
          d="M99.56 88.38a2.77 2.77 0 000-.37h-.92c-.23 0-.58.2-.78.2h-2.23a.5.5 0 000 .17h2.26l.23-.09a3.89 3.89 0 01.48-.05v.14z"
        />
        <rect
          className="cls-8"
          x={95.83}
          y={88.38}
          width={4.01}
          height={1.37}
          rx={0.67}
          transform="rotate(-180 97.835 89.07)"
        />
        <path
          className="cls-10"
          d="M105.9 48.62c-3.9-6.13-8.9-9.82-9.49-9.57-.19-.16-.38-.45-.52-.48s-4 4-4.07 4.66a1.89 1.89 0 00.1.86l-3.59 5.06L93 53.3l2-3.58c.37.52.77 1.09 1.18 1.73 1.88 2.94 3.62 8.31 4 9.7 2.5 2.22 9.79-2.15 11.17-2.87a85.33 85.33 0 00-5.45-9.66z"
        />
        <circle
          className="cls-22"
          cx={36.77}
          cy={91.02}
          r={2.28}
          transform="rotate(-13.28 36.766 91.042)"
        />
        <circle
          className="cls-22"
          cx={118.13}
          cy={91.02}
          r={2.28}
          transform="rotate(-13.28 118.174 91.028)"
        />
        <path
          className="cls-18"
          d="M56.66 34.4c1.82 2.37 2 5.24.51 6.41s-4.23.19-6-2.18-2.05-5.24-.52-6.41 4.2-.22 6.01 2.18z"
        />
        <path
          className="cls-18"
          d="M54.74 40.32c1.88 3.33 2 6.8.36 7.75s-4.56-1-6.44-4.32-2-6.8-.36-7.75 4.56 1 6.44 4.32z"
        />
        <path
          className="cls-18"
          d="M52.54 36.83c.27 2.7-1 5-2.87 5.21s-3.56-1.86-3.83-4.56 1-5 2.88-5.21 3.56 1.86 3.82 4.56zM60.12 37.85c1.47 2 2.54 3.09 2.78 3.53.46.87.49.86-.23 1.53a3.21 3.21 0 01-2.77.68 5.11 5.11 0 01-2.53-1.46 14.68 14.68 0 01-1.81-2.33 7.13 7.13 0 01-1.1-2.14 2.58 2.58 0 01.4-2.29c.33-.39 1.91-.72 2.37-.13s.18 1.16 2.89 2.61z"
        />
        <ellipse
          className="cls-18"
          cx={57.11}
          cy={43.64}
          rx={6.46}
          ry={7.82}
          transform="rotate(-48.69 57.11 43.64)"
        />
        <path
          className="cls-16"
          d="M54.22 41.27l1.49 3.49s-2.15 5.07-2.57 5.69a16.28 16.28 0 01-.92-4.55c0-.51-1.23-5.12-1.23-5.12z"
        />
        <path
          className="cls-23"
          d="M52.93 43.46a3.29 3.29 0 01-4-2.38l-.84-3.3a2 2 0 011.42-2.38l2.74-.7a2 2 0 012.39 1.41l.79 3.13a3.48 3.48 0 01-2.5 4.22z"
        />
        <path
          className="cls-18"
          d="M46.08 37c.44 1.13 2.55 1.36 4.71.52s3.56-2.42 3.13-3.52-2.55-1.36-4.72-.52-3.56 2.41-3.12 3.52z"
        />
        <path
          className="cls-18"
          d="M56.66 38a7.07 7.07 0 010-1.38l-1.26-2.21-1.64-.61-.82 1.79-.71 1s2.2-.36 2.45 2.33c.1 1.16.69 1.24 1.33 1a6.34 6.34 0 01.65-1.92z"
        />
        <path
          className="cls-23"
          d="M56.54 39.13a1 1 0 11-1.24-.74 1 1 0 011.24.74z"
        />
        <path
          className="cls-24"
          d="M65.83 60.55l-7.22 3.68a20.07 20.07 0 00-3-8.66 28 28 0 00-2.08-3 10.4 10.4 0 00-.91-1.08c-.4-.39-.85-.6-1-1.22a3.91 3.91 0 01.05-1.23 9.67 9.67 0 01.45-1.93 3 3 0 011.23-1.52 5.41 5.41 0 012.67-.79c1.22.21 1.89 1.35 2.72 2.28s.56 2.84 1 4a15.09 15.09 0 001.8 3.59c.85 1.24 2.06 2.06 3 3.2a15 15 0 011.32 2.59l-.03.09z"
        />
        <path
          className="cls-23"
          d="M59.93 63.55l-2.59 15.54-.56 18.51 1.45-.08c1-4.5 5.09-12.14 2.72-18.23.57-3.63 8-13 4.9-18.75z"
        />
        <path
          className="cls-4"
          d="M55 98.61l3.33-.19a.31.31 0 00.3-.33v-.3a.28.28 0 00-.3-.27l-2.45.13c-.5 0-1.6.49-1.57 1z"
        />
        <path
          className="cls-24"
          d="M57.79 57.09a4.45 4.45 0 00-.94-.9 10.4 10.4 0 00-2.53-1.11c-.9-.31-2.42-.73-2.88-1.65a2.74 2.74 0 010-1.79c.29-1.41.59-2.82.87-4.23.11-.53.06-1 .49-1.4a2.5 2.5 0 011.37-.51 5.84 5.84 0 013.76 1 6.56 6.56 0 012.36 3.33 8 8 0 01.34 2 8 8 0 002.37 4c1.5 1.52 3.31 2.75 4.5 4.52.89 1.32 1.39 2.87 2.32 4.15A9.91 9.91 0 0075 68c2.54.79 7.12 0 7.8 3.43.31 1.56-.79 3-1.86 3.91-1.83 1.62-4 3-6.32 2.58a26.24 26.24 0 01-3.67-1.29c-2.16-.68-4.41-.38-6.63-.33a9.92 9.92 0 01-4.32-.53 14.92 14.92 0 01-3.73-2.44c-1.12-1-1.62-2.52-2.55-3.68-.37-.47-1.14-.82-1.35 0-.07.26-.13.57-.38.68s-.68-.24-.75-.6c-.25-1.24-.43-1.76.87-2.41A12.41 12.41 0 0056.36 64a11.51 11.51 0 002.15-4.33 3.18 3.18 0 00-.72-2.58z"
        />
        <path
          className="cls-16"
          d="M55.37 46.1c-1.7-.11-1.48 1.74-1.64 8.5a5.55 5.55 0 01-1 3.22c-1.37 1.65-7.93 4.75-7.93 4.75l1.1 1.06s6.34-1.17 8.77-3.71 2.45-5.43 2.48-7.57c.02-2.6-.07-6.14-1.78-6.25z"
        />
        <path
          className="cls-16"
          d="M44.42 61.52a1.7 1.7 0 11-1.88 1.56 1.74 1.74 0 011.88-1.56z"
        />
        <path
          className="cls-22"
          d="M33.5 77.21c0-.11-.32 0-.29.06l3.24 12c.16.57.31 1.14.47 1.71 0 .11.31 0 .28-.06L34 78.91c-.19-.57-.35-1.14-.5-1.7z"
        />
        <path
          className="cls-22"
          d="M30.21 77.84c-1.5 0-2.64-.31-3-1.17-.7-1.62-2.58-9.7-2.66-10l-.07-.3h.31l1.05-.16c1.37-.23 3.68-.6 6.26-.8 2.15-.16 4.55-.11 6.47-.07h1.26v.26c0 .06.16 6.15.09 8.14-.09 2.59-.77 2.73-3.61 3.3l-.53.11a29.54 29.54 0 01-5.57.69zm-5.08-11c.35 1.5 1.95 8.26 2.56 9.66.7 1.6 6.13.48 7.92.12l.53-.11c2.86-.58 3.1-.63 3.17-2.79.07-1.74-.05-6.65-.08-7.84h-.69c-1.91 0-4.29-.1-6.42.07-2.56.19-4.85.57-6.21.79z"
        />
        <path
          className="cls-22"
          d="M30.1 77.44c-1-4.49-2.83-11-3-11.35l.49-.24c.21.42 2 7.25 3 11.47zM32.93 77.44c-.91-4.52-2.27-11.53-2.29-11.6l.54-.11c0 .07 1.38 7.09 2.28 11.6zM35.3 76.59c-.21-1.67-.44-3.71-.65-5.55-.28-2.44-.57-5-.62-5.18l.52-.16c.06.17.22 1.58.65 5.27.21 1.85.44 3.88.64 5.56zM37.67 76.22c0-.47-.07-1.07-.1-1.9s-.08-2.07-.17-3.68a41.69 41.69 0 00-.64-5.35l.54-.11a45.8 45.8 0 01.64 5.43c.1 1.61.14 2.81.18 3.69s.05 1.42.1 1.87z"
        />
        <path
          className="cls-22"
          d="M25.78 71.07l-.14-.53a39.65 39.65 0 017.17-1.19c3.62-.23 6.82-.37 6.86-.37v.55s-3.23.14-6.84.36a40.53 40.53 0 00-7.05 1.18zM26.8 75l-.17-.52a35.34 35.34 0 016.17-1.29 58.47 58.47 0 016.61-.36v.54a56.06 56.06 0 00-6.54.37A34.5 34.5 0 0026.8 75zM41.05 67.61h2.92v1.55h-2.92z"
        />
        <path className="cls-22" d="M39.22 68.07h2.92v.73h-2.92z" />
        <path
          className="cls-23"
          d="M92.76 33.63a1.24 1.24 0 101-1.47 1.25 1.25 0 00-1 1.47z"
        />
        <path
          className="cls-23"
          d="M90.91 40a4 4 0 003.16-4.77l-1-5a.82.82 0 00-1-.64l-5.81 1.17a.82.82 0 00-.63 1l1.11 5.5A3.51 3.51 0 0090.91 40z"
        />
        <path
          className="cls-18"
          d="M92.7 30.85a2.24 2.24 0 00-1.7-.54 6.86 6.86 0 00-1.73.61 7.46 7.46 0 01-2.75.59 4.05 4.05 0 01-2.09-.42 2.15 2.15 0 01-1.17-1.69 2.45 2.45 0 01.5-1.51 4 4 0 012.28-1.56c1.73-.44 3.6.31 5.32-.16a8.33 8.33 0 011.19-.31 2.16 2.16 0 011.62.55 2.7 2.7 0 01.83 1.52 6.28 6.28 0 01-.13 2.4 6.08 6.08 0 01-.21.94c-.11.32-.2.64-.3 1-.18.65-.43 1.41-.57 2.07a1.89 1.89 0 01-.22-.83c0-.27 0-.53-.08-.79a2.81 2.81 0 00-.79-1.87z"
        />
        <path
          className="cls-24"
          d="M122.67 85.11a64.93 64.93 0 00-29 24.07c-.12.19-.42 0-.3-.17a61.69 61.69 0 0121.69-20.42 54.64 54.64 0 017.61-3.52zM124.79 85.48a1.28 1.28 0 00.68-.82c.23-.63.22-1.49-.37-1.82a1.18 1.18 0 00-1.36.28 1.93 1.93 0 00-.3 1.53c.35 1.03 1.08.92 1.35.83zM122.9 89.39a1.27 1.27 0 00.67-.82c.23-.63.23-1.49-.36-1.82a1.19 1.19 0 00-1.36.29 1.89 1.89 0 00-.31 1.52c.35 1.03 1.09.93 1.36.83z"
        />
        <path
          className="cls-24"
          d="M119.4 90.75a1.26 1.26 0 00.68-.81c.23-.64.22-1.5-.37-1.83a1.2 1.2 0 00-1.36.29 1.91 1.91 0 00-.3 1.52c.35 1.08 1.08.93 1.35.83zM121.67 83.5a1.25 1.25 0 00-.58-.89 1.5 1.5 0 00-1.85-.2 1.18 1.18 0 00-.13 1.38 1.9 1.9 0 001.36.75c1.09-.02 1.21-.76 1.2-1.04zM118.45 85.48a1.25 1.25 0 00-.58-.89c-.54-.41-1.36-.66-1.85-.19a1.18 1.18 0 00-.13 1.38 1.89 1.89 0 001.37.74c1.09-.02 1.2-.76 1.19-1.04zM110.82 91.51a3.35 3.35 0 002.25 1.85 4.65 4.65 0 002.72-.35 3.35 3.35 0 00-2.71-2 4.74 4.74 0 00-2.26.5zM105.45 95.55a2.08 2.08 0 001.42 1.16 2.93 2.93 0 001.72-.22 2.11 2.11 0 00-1.71-1.27 3 3 0 00-1.43.33zM107.39 94a3.33 3.33 0 001.75-2.32 4.7 4.7 0 00-.46-2.7 3.35 3.35 0 00-1.9 2.8 4.71 4.71 0 00.61 2.22z"
        />
        <path
          className="cls-25"
          d="M82.78 110.09a36.12 36.12 0 00-9.52-20.78l-.07.06a36.54 36.54 0 018.59 15.76 40 40 0 01.92 5h.08z"
        />
        <path
          className="cls-25"
          d="M75.71 92.49A23.58 23.58 0 0173 90.74a6.53 6.53 0 01-2-2.45c-.24-.56-.32-1.33.17-1.68a1.07 1.07 0 011.09 0 2.72 2.72 0 01.82.8 20 20 0 012.92 5.2zM78.4 96.48a4.85 4.85 0 00-5-2.62 2 2 0 00-1 .44 1 1 0 00-.36 1.19A1.28 1.28 0 0073 96a3.79 3.79 0 001-.11 8.05 8.05 0 014.18.41.9.9 0 01.22.18zM80 99.56a4.86 4.86 0 00-5-2.62 1.91 1.91 0 00-1 .45 1 1 0 00-.36 1.18 1.3 1.3 0 001 .53 4.24 4.24 0 001-.1 7.85 7.85 0 014.18.41 1 1 0 01.18.15zM77.29 94.73a13.08 13.08 0 01-.61-1.5 5.55 5.55 0 01-.26-1 3.32 3.32 0 01.82-2.73 2.26 2.26 0 011.09-.71 1.44 1.44 0 011.26.21 1.1 1.1 0 01.41 1.19 2.58 2.58 0 01-1 1 4.35 4.35 0 00-1.71 3.54zM79.16 98.06a12.16 12.16 0 01-.6-1.51 4.84 4.84 0 01-.27-1 3.35 3.35 0 01.82-2.73 2.3 2.3 0 011.09-.71 1.44 1.44 0 011.26.21 1.08 1.08 0 01.39 1.18 2.58 2.58 0 01-.95 1 4.36 4.36 0 00-1.74 3.56z"
        />
        <path
          className="cls-9"
          d="M57.11 87.93c-.09 2 .46 4.35 2.86 4.58 2.07.19 3.63-1.34 4.5-3.06a.1.1 0 01.18.09C63.73 91.37 62 93 59.84 92.7c-2.42-.3-3.05-2.7-2.84-4.78 0-.07.12-.06.12 0z"
        />
        <path
          className="cls-9"
          d="M59.27 87.48a6 6 0 00-.45 2.58 7.38 7.38 0 00.86 2.32c0 .08-.08.17-.14.1a4.3 4.3 0 01-.29-5z"
        />
        <path
          className="cls-9"
          d="M61 88.13a8 8 0 01-1.45 4.27.13.13 0 01-.22-.14c.31-.64.68-1.24.94-1.91a10.9 10.9 0 00.6-2.24.07.07 0 01.13 0zM63.3 88.35A5.5 5.5 0 0162 91a4.82 4.82 0 01-2.27 1.65c-.11 0-.14-.13-.07-.19.35-.28.79-.46 1.15-.73a6.46 6.46 0 001-1 9.09 9.09 0 001.4-2.41h.07zM56.49 87.62a.54.54 0 00-.1.63.64.64 0 00.33.25.82.82 0 00.73-.13.66.66 0 00.19-.7.55.55 0 00-.62-.33.91.91 0 00-.53.28z"
        />
        <path
          className="cls-9"
          d="M63.4 88.54a.57.57 0 00.57-.17.49.49 0 00.08-.33.62.62 0 00-.39-.47.71.71 0 00-.66.13.41.41 0 000 .57.71.71 0 00.4.27zM59.09 87.71a.55.55 0 00.56-.17.48.48 0 00.08-.33.59.59 0 00-.39-.46.68.68 0 00-.66.12.41.41 0 000 .57.71.71 0 00.41.27zM64 89.46a.56.56 0 00-.1.63.72.72 0 00.37.26.77.77 0 00.7-.14.66.66 0 00.19-.7.56.56 0 00-.62-.33 1 1 0 00-.54.28zM60.66 87.11a.92.92 0 00-.09.79.34.34 0 00.1.16.38.38 0 00.15.09 1.17 1.17 0 00.41.1.72.72 0 00.6-.44.6.6 0 00.06-.23.5.5 0 00-.15-.45.84.84 0 00-.57-.24.66.66 0 00-.51.22zM59.84 91.75a93.38 93.38 0 00-1.6 10.65 72.93 72.93 0 00.24 11 .12.12 0 11-.24 0 59.94 59.94 0 01-.25-10.8 51.69 51.69 0 011.74-10.85.06.06 0 11.11 0z"
        />
        <path
          className="cls-9"
          d="M59.72 95.33a2.19 2.19 0 001.47 1 2.21 2.21 0 00-.35-1.78 2.91 2.91 0 00-1.45-1 2.4 2.4 0 00.33 1.78zM58.36 94.93a2.14 2.14 0 001-1.46 2.23 2.23 0 00-1.77.34 2.84 2.84 0 00-1 1.45 2.33 2.33 0 001.77-.33zM58 103.23a1.74 1.74 0 01-1.41-.52 2.35 2.35 0 01-.59-1.31 1.72 1.72 0 011.61.68 2.43 2.43 0 01.39 1.15zM58 105.77a2.41 2.41 0 002-.67 3.4 3.4 0 00.83-1.8 2.41 2.41 0 00-2.28.89 3.47 3.47 0 00-.55 1.58zM43.1 98.67c1.7.75 3.39 2.12 2.61 4.17-.66 1.79-2.54 2.45-4.31 2.48a.11.11 0 000 .21c1.91 0 4-.82 4.57-2.8s-1-3.51-2.82-4.17c-.07 0-.11.08 0 .11z"
        />
        <path
          className="cls-9"
          d="M41.87 100.27a5.55 5.55 0 012.22.62 6.59 6.59 0 011.64 1.69c.06.07.18 0 .15-.1a3.93 3.93 0 00-4-2.24z"
        />
        <path
          className="cls-9"
          d="M41.68 102a7.21 7.21 0 004.12.53c.15 0 .11-.26 0-.26-.65 0-1.29.06-1.94 0a10.57 10.57 0 01-2.09-.4c-.07 0-.12.09 0 .12zM41 103.93a5 5 0 002.62 0 4.67 4.67 0 002.34-1.21.11.11 0 00-.13-.17 13.44 13.44 0 01-2.28 1.13 9.05 9.05 0 01-2.54.19v.07zM43.29 98.34a.5.5 0 01.55.17.51.51 0 01.07.38.68.68 0 01-.4.54.56.56 0 01-.64-.12.5.5 0 010-.64.81.81 0 01.42-.33z"
        />
        <path
          className="cls-9"
          d="M41 104a.51.51 0 01-.36.39.35.35 0 01-.3-.07.53.53 0 01-.23-.5.59.59 0 01.37-.49.37.37 0 01.48.2.64.64 0 01.04.47zM42.13 100.2a.51.51 0 01-.36.4.42.42 0 01-.31-.07.54.54 0 01-.22-.51.59.59 0 01.37-.48.35.35 0 01.47.19.69.69 0 01.05.47zM41.54 104.83a.49.49 0 01.56.17.56.56 0 01.07.38.72.72 0 01-.4.54.6.6 0 01-.65-.12.5.5 0 010-.64.81.81 0 01.42-.33zM41 101.14a.81.81 0 01.68.24.45.45 0 01.1.14.86.86 0 010 .16 1 1 0 01-.08.38.69.69 0 01-.61.32.45.45 0 01-.2 0 .47.47 0 01-.32-.31.74.74 0 010-.56.55.55 0 01.43-.37zM48.09 103.76a2 2 0 01.21 1.59 2 2 0 01-1.32-1 2.61 2.61 0 01-.27-1.61 2.13 2.13 0 011.38 1.02z"
        />
        <path
          className="cls-9"
          d="M48.22 102.59a2 2 0 01-1.59.21 2.05 2.05 0 011-1.33 2.69 2.69 0 011.61-.27 2.17 2.17 0 01-1.02 1.39z"
        />
        <path
          className="cls-9"
          d="M45.46 102.41a46.55 46.55 0 017.42 3.41 30 30 0 016.32 5.07c.11.12.34 0 .23-.18a3.34 3.34 0 00-.35-.4c-.08-.09-.2 0-.15.12a2.26 2.26 0 00.24.43l.24-.18a29.39 29.39 0 00-6.4-5.09 36.76 36.76 0 00-7.54-3.25s-.06 0 0 .07z"
        />
        <path
          className="cls-9"
          d="M55.45 107.24a2.37 2.37 0 01-1.72 1.2 3.39 3.39 0 01-1.94-.4 2.41 2.41 0 012.07-1.3 3.41 3.41 0 011.59.5z"
        />
        <path
          className="cls-25"
          d="M92.46 109.19l.16.11a30.35 30.35 0 019.39-8A46.89 46.89 0 01113 97v-.18a47.15 47.15 0 00-11 4.34 30.8 30.8 0 00-9.54 8.03z"
        />
        <path
          className="cls-25"
          d="M113.22 98.59a2.83 2.83 0 01-2.57-1.06c-.08-.28.47-1.15 1.35-1.62a5.28 5.28 0 012.72-.37 21.17 21.17 0 012.52.68c-.24.16-1.62 2.23-4.02 2.37zM106.27 99.18a5.34 5.34 0 014.31 0 8.58 8.58 0 012.76 1.81 9.48 9.48 0 01-3.81-.07 7.86 7.86 0 01-3.26-1.74zM103.13 100.6a5.34 5.34 0 014.31 0 8.62 8.62 0 012.77 1.81 9.53 9.53 0 01-3.82-.07 7.86 7.86 0 01-3.26-1.74zM105.36 99.45a5.33 5.33 0 003.4-2.65 8.45 8.45 0 001.07-3.12 9.46 9.46 0 00-3 2.4 7.84 7.84 0 00-1.47 3.37zM101.2 101.69a5.34 5.34 0 002.63-3.41 8.53 8.53 0 00.24-3.3 9.61 9.61 0 00-2.26 3.08 7.75 7.75 0 00-.61 3.63zM97.84 104a5.3 5.3 0 002-3.8 8.52 8.52 0 00-.29-3.29 9.55 9.55 0 00-1.73 3.4 7.87 7.87 0 00.02 3.69zM69 111.83l-.17.06A30.53 30.53 0 0062 101.64a47.09 47.09 0 00-9.39-7.16l.1-.16a47.41 47.41 0 019.42 7.19A30.57 30.57 0 0169 111.83z"
        />
        <path
          className="cls-25"
          d="M52 96a2.83 2.83 0 002.76-.32c.15-.25-.14-1.24-.86-1.92a5.23 5.23 0 00-2.52-1.11 22.28 22.28 0 00-2.6 0c.13.15.92 2.53 3.22 3.35zM58.49 98.43a5.27 5.27 0 00-4.14-1.18 8.45 8.45 0 00-3.16 1 9.63 9.63 0 003.7 1 7.74 7.74 0 003.6-.82zM61.12 100.65A5.35 5.35 0 0057 99.47a8.45 8.45 0 00-3.16 1 9.62 9.62 0 003.7 1 7.83 7.83 0 003.58-.82z"
        />
        <path
          className="cls-25"
          d="M59.29 98.94a5.33 5.33 0 01-2.55-3.47 8.39 8.39 0 01-.17-3.31 9.61 9.61 0 012.19 3.13 7.83 7.83 0 01.53 3.65zM62.69 102.23a5.3 5.3 0 01-1.6-4 8.6 8.6 0 01.66-3.23 9.61 9.61 0 011.34 3.58 7.8 7.8 0 01-.4 3.65zM65.27 105.4a5.31 5.31 0 01-.92-4.21 8.26 8.26 0 011.18-3.09 9.74 9.74 0 01.74 3.75 7.8 7.8 0 01-1 3.55z"
        />
        <path
          className="cls-9"
          d="M69.86 93.91c-.51 1.54-1.57 3.12-3.43 2.61A3.82 3.82 0 0163.94 93a.08.08 0 00-.16 0 4 4 0 002.69 3.72c1.89.46 3-1.14 3.48-2.76 0 0-.07-.08-.09 0z"
        />
        <path
          className="cls-9"
          d="M68.37 93a4.66 4.66 0 01-.37 2 6 6 0 01-1.3 1.49c-.05 0 0 .14.08.11a3.41 3.41 0 001.61-3.6z"
        />
        <path
          className="cls-9"
          d="M66.87 93a6.36 6.36 0 00-.12 3.59.1.1 0 00.2 0c0-.57-.16-1.12-.16-1.69A8.86 8.86 0 0167 93c0-.06-.08-.08-.1 0zM65.12 92.48a4.44 4.44 0 00.25 2.34 3.85 3.85 0 001.23 1.87c.07 0 .14-.06.1-.12-.18-.32-.45-.57-.65-.87a5.67 5.67 0 01-.5-1 7.14 7.14 0 01-.37-2.19h-.06zM70.41 93.86a.43.43 0 01-.1.49.47.47 0 01-.32.1.62.62 0 01-.51-.31.5.5 0 01.06-.57.43.43 0 01.55-.07.7.7 0 01.32.36z"
        />
        <path
          className="cls-9"
          d="M65 92.59a.46.46 0 01-.37-.28.32.32 0 010-.27.47.47 0 01.42-.24.53.53 0 01.45.28.32.32 0 01-.13.43.61.61 0 01-.37.08zM68.45 93.19a.43.43 0 01-.37-.28.36.36 0 010-.27.49.49 0 01.42-.24.54.54 0 01.45.28.31.31 0 01-.13.43.6.6 0 01-.37.08zM64.28 93.11a.41.41 0 01-.1.49.46.46 0 01-.34.09.57.57 0 01-.48-.3.51.51 0 010-.57.44.44 0 01.56-.07.7.7 0 01.36.36zM67.44 92.3a.67.67 0 01-.16.61.35.35 0 01-.11.1A.32.32 0 0167 93a.73.73 0 01-.33 0 .6.6 0 01-.33-.5.55.55 0 010-.18.39.39 0 01.24-.3.68.68 0 01.49 0 .51.51 0 01.37.28zM66.74 96a75.68 75.68 0 01-1.81 8.4 57.93 57.93 0 01-3.28 8.1.1.1 0 00.18.09 47.71 47.71 0 003.23-8A41.27 41.27 0 0066.83 96c0-.06-.08-.08-.09 0z"
        />
        <path
          className="cls-9"
          d="M65.82 98.69a1.74 1.74 0 01-1.37.32 1.8 1.8 0 01.76-1.23 2.28 2.28 0 011.38-.37 1.86 1.86 0 01-.77 1.28zM67 98.78a1.72 1.72 0 01-.32-1.36 1.8 1.8 0 011.24.75 2.36 2.36 0 01.36 1.38 1.86 1.86 0 01-1.28-.77zM64.91 105.09a1.4 1.4 0 001.2 0 2 2 0 00.79-.82 1.38 1.38 0 00-1.4 0 1.93 1.93 0 00-.59.82zM64.13 107a2 2 0 01-1.29-1.06 2.74 2.74 0 01-.11-1.58 1.91 1.91 0 011.44 1.3 2.77 2.77 0 01-.04 1.34zM77.27 105.88c-1.48.08-3.12.63-3.13 2.37a3.5 3.5 0 002.52 3.07.08.08 0 11-.06.15 3.6 3.6 0 01-2.6-3.37c.11-1.74 1.78-2.32 3.29-2.32v.1z"
        />
        <path
          className="cls-9"
          d="M77.74 107.42a4.53 4.53 0 00-1.83-.16 5 5 0 00-1.7.79.07.07 0 01-.09-.11 3.14 3.14 0 013.63-.54z"
        />
        <path
          className="cls-9"
          d="M77.4 108.75a5.72 5.72 0 01-3.22-.77c-.11-.06 0-.22.1-.18.48.18.94.41 1.44.56a9.41 9.41 0 001.67.29c.06 0 .07.1 0 .1zM77.37 110.41a4.1 4.1 0 01-2-.75 3.66 3.66 0 01-1.4-1.57.09.09 0 01.15-.08 10.13 10.13 0 001.38 1.48 6.73 6.73 0 001.84.86v.06zM77.22 105.59a.4.4 0 00-.46 0 .49.49 0 00-.16.27.54.54 0 00.15.51.46.46 0 00.51.1.4.4 0 00.2-.48.59.59 0 00-.24-.4z"
        />
        <path
          className="cls-9"
          d="M77.32 110.42a.38.38 0 00.16.39.32.32 0 00.25 0 .44.44 0 00.31-.31.49.49 0 00-.14-.47.29.29 0 00-.41 0 .56.56 0 00-.17.39zM77.56 107.3a.38.38 0 00.16.39.32.32 0 00.25 0 .42.42 0 00.31-.31.49.49 0 00-.14-.47.29.29 0 00-.41 0 .56.56 0 00-.17.39zM76.69 110.91a.39.39 0 00-.46 0 .4.4 0 00-.16.26.57.57 0 00.14.52.46.46 0 00.52.09.39.39 0 00.2-.47.69.69 0 00-.24-.4zM78.17 108.33a.64.64 0 00-.57 0 .28.28 0 00-.11.08.39.39 0 00-.06.11.8.8 0 000 .31.53.53 0 00.36.41.44.44 0 00.16 0 .37.37 0 00.33-.14.61.61 0 00.13-.43.43.43 0 00-.24-.34zM72.11 108.27a1.57 1.57 0 00-.61 1.12 1.61 1.61 0 001.27-.36 2.13 2.13 0 00.66-1.13 1.7 1.7 0 00-1.32.37z"
        />
        <path
          className="cls-9"
          d="M72.34 107.35a1.6 1.6 0 001.13.61 1.63 1.63 0 00-.36-1.27A2.12 2.12 0 0072 106a1.7 1.7 0 00.34 1.35z"
        />
        <path
          className="cls-9"
          d="M74.46 108a37.2 37.2 0 00-6.5.45 23.44 23.44 0 00-6.15 2c-.12.06-.23-.13-.12-.21l.37-.2c.09 0 .15.08.09.14a1.79 1.79 0 01-.31.25l-.12-.2a23.34 23.34 0 016.21-2 29.13 29.13 0 016.53-.29s0 .06 0 0z"
        />
        <path
          className="cls-9"
          d="M65.64 108.79a1.94 1.94 0 00.94 1.38 2.7 2.7 0 001.56.24 1.92 1.92 0 00-1.14-1.55 2.71 2.71 0 00-1.36-.07z"
        />
      </g>
    </g>
  </svg>
);
